export const iconFontAwesomeMedicalHealthPrescriptionBottle = (
	<i className="fa-solid fa-prescription-bottle"></i>
);
